"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconChevronDownOutline = _interopRequireDefault(require("./IconChevronDownOutline"));
var IconChevronUpOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconChevronDownOutline.default).withConfig({
  displayName: "IconChevronUpOutline",
  componentId: "c11n-8-107-0__sc-1d3o5nk-0"
})(["transform:rotate(180deg);"]);
var _default = IconChevronUpOutline;
exports.default = _default;